var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Number(_vm.limit) >= _vm.maxCount)?_c('div',{staticClass:"g-cell g-cols g-cols--12 ns-space_mt ns-space_mt--3 ns-space_mb ns-space_mb--3"},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }